import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { Voucher, VoucherAutoApply, VouchersToApply } from '../models';

export enum VoucherActionTypes {
  GetVoucherAction = '[Voucher] GetVoucherAction',
  GetVoucherSuccessAction = '[Voucher] GetVoucherSuccess',
  GetVoucherErrorAction = '[Voucher] GetVoucherError',
  SetVoucherAutoApplyAction = '[Voucher] SetVoucherAutoApplyAction',
  SetVoucherAutoApplySuccessAction = '[Voucher] SetVoucherAutoApplySuccess',
  SetVoucherAutoApplyErrorAction = '[Voucher] SetVoucherAutoApplyError',
  SetLoyaltyVouchersToApplyAction = '[Voucher] SetLoyaltyVouchersToApplyAction',
}

export const getVoucherAction = createAction(VoucherActionTypes.GetVoucherAction);
export const getVoucherSuccessAction = createAction(VoucherActionTypes.GetVoucherSuccessAction, props<{ voucher: Voucher[] }>());
export const getVoucherErrorAction = createAction(VoucherActionTypes.GetVoucherErrorAction, props<{ failure: AppStateFailure }>());
export const setVoucherAutoApplyAction = createAction(
  VoucherActionTypes.SetVoucherAutoApplyAction,
  props<{ voucherAutoApply: VoucherAutoApply }>()
);
export const setVoucherAutoApplySuccessAction = createAction(VoucherActionTypes.SetVoucherAutoApplySuccessAction);
export const setVoucherAutoApplyErrorAction = createAction(
  VoucherActionTypes.SetVoucherAutoApplyErrorAction,
  props<{ failure: AppStateFailure }>()
);
export const setLoyaltyVouchersToApplyAction = createAction(
  VoucherActionTypes.SetLoyaltyVouchersToApplyAction,
  props<{ loyaltyVouchersToApply: VouchersToApply[] }>()
);
